import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
});

function Import(props) {
    const classes = useStyles();

    return (
        <h1>Import settings</h1>
    );
}

export default Import